const rtlLanguageCodes = new Set(["ar", "fa"]);

const getLanguageDir = (code: string) =>
  rtlLanguageCodes.has(code) ? "rtl" : "ltr";

export default getLanguageDir;
